<template>
  <svg
    id="Rotate_icon"
    data-name="Rotate icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect
      id="Rectangle_1862"
      data-name="Rectangle 1862"
      width="24"
      height="24"
      fill="none"
    />
    <g
      id="Rectangle_1864"
      data-name="Rectangle 1864"
      fill="none"
      stroke="#2d323c"
      stroke-width="1"
    >
      <rect width="14" height="24" rx="2" stroke="none" />
      <rect x="0.5" y="0.5" width="13" height="23" rx="1.5" fill="none" />
    </g>
    <path
      id="Path_2392"
      data-name="Path 2392"
      d="M.5,9V2.333A1.833,1.833,0,0,1,2.333.5H11.5a1.982,1.982,0,0,1,2,1.833V9"
      transform="translate(24 10) rotate(90)"
      fill="none"
      stroke="#2d323c"
      stroke-width="1"
    />
    <path
      id="Path_2393"
      data-name="Path 2393"
      d="M6459,961s5.149-.022,5.76,4.247"
      transform="translate(-6444 -958)"
      fill="none"
      stroke="#2d323c"
      stroke-width="1"
    />
    <path
      id="Polygon_25"
      data-name="Polygon 25"
      d="M2,0,4,3H0Z"
      transform="matrix(-0.966, 0.259, -0.259, -0.966, 23.14, 8.398)"
      fill="#2d323c"
    />
  </svg>
</template>

<script>
export default {
  name: 'RotateDevice',
}
</script>

<style lang="scss" scoped></style>
